import { Typography } from '@mui/material';
import Col from 'components/base/col';
import { useAnchorParams } from 'hooks/useAnchorParams';
import { useIsMobile } from 'hooks/useIsMobile';
import React from 'react';
import { nbsp } from 'utils/constants';

export default function Header() {
  const { fontSize } = useAnchorParams();
  const isMobile = useIsMobile();

  const mainVariant = isMobile ? 'f24' : 'f42';
  const secondVariant = isMobile ? 'f14' : 'f20';

  return (
    <Col sx={{ gap: isMobile ? 4 : 3 }}>
      <Typography
        sx={{
          fontWeight: 'bold',
          whiteSpace: isMobile ? 'pre-line' : 'nowrap',
          fontSize: fontSize ? `${fontSize} !important` : '',
        }}
        variant={mainVariant}
      >
        {'Мониторинг аварийности'}
      </Typography>
      <Typography
        variant={secondVariant}
        sx={{
          whiteSpace: isMobile ? 'pre-line' : 'nowrap',
          lineHeight: '19px',
        }}
      >
        {`Это платформа сбора данных о${nbsp}ДТП с${nbsp}пострадавшими, которые произошли в${nbsp}Москве`}
      </Typography>
    </Col>
  );
}
